import 'lazysizes';
$(document).ready(function () {
  $(".carousel-first").owlCarousel({
    loop: true,
    margin: 25,
    responsiveClass: true,
    autoplay: false,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        nav: true,
      },
      580: {
        items: 2,
        nav: false,
      },
      1000: {
        items: 3,
        nav: true,
      },
    },
  });
  $(".carousel-second").owlCarousel({
    loop: true,
    margin: 0,
    responsiveClass: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        nav: false,
      },
      768: {
        items: 1,
        nav: false,
      },
      1000: {
        items: 1,
        nav: false,
      },
      1400: {
        items: 1,
        nav: true,
      },
    },
  });

  $("#map area").each(function (i) {
    $(this).hover(
      function () {
        $(".map-block .state" + (i + 1)).fadeIn(200);
        $(".map-list .stateList" + (i + 1)).addClass("active");
      },
      function () {
        $(".map-block .state" + (i + 1)).fadeOut(200);
        $(".map-list .stateList" + (i + 1)).removeClass("active");
      }
    );
  });
  $(".map-list a").hover(
    function () {
      $(this).addClass("active");
      var pClass = $(this).parent().attr("class");
      var stateId = pClass.replace(/[^\d.]/g, "");
      $(".map-block .state" + stateId).fadeIn(200);
    },
    function () {
      $(this).removeClass("active");
      var pClass = $(this).parent().attr("class");
      var stateId = pClass.replace(/[^\d.]/g, "");
      $(".map-block .state" + stateId).fadeOut(200);
    }
  );
  $(".seventh-block__categories").slideUp();

  $(".categories-button").click(function () {
    if (!$(this).hasClass("active")) {
      $(this).addClass("active");
      $(".seventh-block__categories").slideDown("slow");
    } else {
      $(this).removeClass("active");
      $(".seventh-block__categories").slideUp("slow");
    }
    return false;
  });

  $('[data-toggle="more-activity"]').click(function (event) {
    event.preventDefault();
    $(".sixth-block__link").fadeIn("slow");
    $(this).closest(".button-wrap").remove();
  });
});

$(document).ready(function () {
  $(".mobile-menu").removeClass("active");
  $(".header__main").removeClass("z-1000");

  $(".mobile-menu-button").click(function () {
    $(".header__main").addClass("z-1000");
    var mobmenu = $(this).attr("data-target");
    $(mobmenu).addClass("active");
  });

  $(".mobile-menu").click(function () {
    $(".mobile-menu").removeClass("active");
    setTimeout(function () {
      $(".header__main").removeClass("z-1000");
    }, 300);
  });

  $(".mobile-user-menu").removeClass("active");

  $(".mobile-user-menu").click(function () {
    $(".mobile-user-menu").removeClass("active");
    setTimeout(function () {
      $(".header__main").removeClass("z-1000");
    }, 300);
  });

  $(".footer .mobile-menu-button").click(function () {
    $(".header__main").removeClass("z-1000");
    $(".footer").addClass("z-1000");
  });
  $(".footer .mobile-menu").click(function () {
    setTimeout(function () {
      $(".footer").removeClass("z-1000");
    }, 1000);
  });

  $(".collapse")
    .on("shown.bs.collapse", function () {
      $(this)
        .parent()
        .find(".fa-plus")
        .removeClass("fa-plus")
        .addClass("fa-minus");
    })
    .on("hidden.bs.collapse", function () {
      $(this)
        .parent()
        .find(".fa-minus")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    });

  (function () {
    var windowSize = $(window).width(); // Could've done $(this).width()

    if (!$("header").hasClass("sticky_header")) return;

    if (windowSize >= 768) {
      $(window).scroll(function () {
        var sticky = $(".header__main"),
          scroll = $(window).scrollTop(),
          headerHeight = $(".header__helper");
        if (scroll >= 15) {
          sticky.addClass("fixed");
          // headerHeight.css('min-height', '100px');
          $(".header .header__sticky .row.bottom-border").hide();
          $(".header__main").css({
            background:
              "linear-gradient(to right, #354672 0%, #394f7e 12%, #394f7e 12%, #3d659d 57%, #4174b4 100%)",
            "z-index": "100",
          });
        } else {
          sticky.removeClass("fixed");
          // headerHeight.css('min-height', '202px');
          $(".header .header__sticky .row.bottom-border").show();
          $(".header__main").css({ background: "unset", "z-index": "13" });
        }
      });
    }
  })();

  if ($(window).width() < 767) {
    $(window).scroll(function () {
      if ($(window).scrollTop() > 100) {
        $(".header__sticky").addClass("sticky-scrolled");
        $(".header__main").addClass("z-1000");
      } else {
        $(".header__sticky").removeClass("sticky-scrolled");
        $(".header__main").removeClass("z-1000");
      }
    });
  }
});

(function ($) {
  var categories = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace("label"),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    identify: function (category) {
      return category.value;
    },
    local: CATEGORY_OPTIONS,
  });

  $("input[data-trigger=suggestions]").each(function () {
    $(this).typeahead(
      {
        hint: true,
        highlight: true,
        minLength: 1,
      },
      {
        name: "categories",
        display: "label",
        source: categories,
      }
    );
  });

  $("#home-search-form").submit(function () {
    var searchText = $("#home-search-form .tt-input")[0].value;

    var found = CATEGORY_OPTIONS.find(function (category) {
      return category.label === searchText;
    });

    if (found) {
      // searched category found
      $("input[name=category]").val(found.value);
      $("input[name=search]").val("");
    } else {
      $("input[name=category]").val("");
    }

    return true;
  });

  var lang_button = $(".lang-menu__button");
  lang_button.click(function () {
    var $this = $(this);
    $this.next().toggleClass("show");
    $this.parent().toggleClass("show");
  });

  $(document).click(function (e) {
    if (e.target.classList[0] !== "lang-menu__button") {
      lang_button.parent().removeClass("show");
      lang_button.next().removeClass("show");
    }
  });

  $(".auth__user").click(function () {
    $(".header__main").addClass("z-1000");
    var usrmenu = $(this).attr("data-target");
    $(usrmenu).addClass("active");
    // return false;
  });

  window.onload = function () {
    setTimeout(function () {
      var map_script = document.createElement("script");
      map_script.type = "text/javascript";
      map_script.src =
        "https://maps.googleapis.com/maps/api/js?key={{map_api_key}}&libraries=places".replace(
          /{{map_api_key}}/,
          api_key
        );
      $("body").append(map_script);
      setTimeout(function () {
        var loc = $("#input-address-location");
        new google.maps.places.Autocomplete(loc[0], {});
        loc.on("keypress", function (e) {
          if (e.key === "Enter") e.preventDefault();
        });
      }, 500);
    }, 3000);
  };
})(jQuery);
